import { Persona } from '../intranet/model/persona';
import { Representante } from '../intranet/model/representante';

export class Asistente extends Persona {
  public index: number;
  public id: number;
  public idFoto: number;
  public tipo = '';
  public tipoAsistente = '';
  public idAsamblea: number;
  public representante: Representante = new Representante();
  public fechaRegistro: Date;
  public usuarioRegistro = '';
  public flagVoto = '0';
  public peso = '';
  public factor = 0.0;
  public cuotas = 0.0;
  public tipoDocumentoR = '';
  public numeroDocumentoR = '';
  public miembros: Asistente[] = [];

}
